/**
 * Copyright (C), 2012-2021, Sichuan Xiaoka Technology Co., Ltd.
 * */
import customSearch from './customTable/customSearch'
import customTable from './customTable/customTable'
import chooseAddress from './chooseAddress'
import upImg from './upImg'
import tabFrame from './tabFrame'
import customTabTime from './customTabTime'
import Card from './Card.vue'
import licensePlate from './licensePlate'
import CustomTag from './CustomTag.vue'
import BaseChart from './BaseChart.vue'
import PageHeader from './PageHeader/PageHeader.vue'


export default {
    install(Vue) {
        Vue.component('customSearch', customSearch);
        Vue.component('customTable', customTable);
        Vue.component('chooseAddress', chooseAddress);
        Vue.component('upImg', upImg);
        Vue.component('tabFrame', tabFrame);
        Vue.component('customTabTime', customTabTime);
        Vue.component('licensePlate', licensePlate);
        Vue.component('Card', Card);
        Vue.component('CustomTag', CustomTag);
        Vue.component('BaseChart', BaseChart);
        Vue.component('PageHeader', PageHeader);
    }
}